<template>
  <div class="change-password boxShadow">
    <el-form
      class="change-password-form"
      :model="formData"
      :rules="formDataRules"
      ref="ruleForm"
    >
      <el-form-item>
        <el-input disabled :value="phoneNumber" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="formData.password"
          type="password"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-form-item prop="passwordSecond">
        <el-input
          v-model="formData.passwordSecond"
          type="password"
          placeholder="确认密码"></el-input>
      </el-form-item>
      <el-form-item prop="captcha" class="captcha">
        <el-input
          v-model="formData.captcha"
          placeholder="短信验证码"></el-input>
        <SendCode
          size="small"
          :mobile="phoneNumber"
          @start="sendCode"></SendCode>
      </el-form-item>
      <el-form-item>
        <el-button style="width: 100%;background: #287CF3" type="primary" @click="submit">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import SendCode from "../../components/common/sendCode.vue";
export default {
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formData.passwordSecond !== "") {
          this.$refs.ruleForm.validateField("passwordSecond");
        }
        callback();
      }
    };
    const validatePasswordSecond = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formData.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        captcha: "",
        password: "",
        passwordSecond: ""
      },
      formDataRules: {
        password: [{ validator: validatePassword, trigger: "blur" }],
        passwordSecond: [
          { validator: validatePasswordSecond, trigger: "blur" }
        ],
        captcha: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ]
      }
    };
  },
  components: {
    SendCode
  },

  computed: {
    phoneNumber() {
      return this.$store.state.user.info.mobile;
    },
    userId() {
      return this.$store.state.user.info.id;
    }
  },
  methods: {
    submit() {
      this.$refs["ruleForm"].validate(async valid => {
        if (!valid) {
          return false;
        }
        const res = await this.$axios({
          url: `/portal/users/change-password?debug=true`,
          method: "PUT",
          data: {
            ...this.formData
          }
        });
        if (res.code === 200) {
          this.$message({ type: "success", message: "密码修改成功！" });
        } else {
          this.$message({ type: "error", message: res.message });
        }
      });
    },
    sendCode() {
      const res = this.$axios({
        url: "/portal/message/sms/send?debug=true",
        method: "POST",
        data: {
          mobile: this.phoneNumber,
          smsTemplateType: "REGIST"
        }
      });
      if (res.code === 200) {
        this.$message({
          type: "success",
          message: "发送短信验证码成功"
        });
      }
    }
  }
};
</script>

<style lang="scss">
.change-password {
  // min-height: 600px;
  width: 1064px;
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  .captcha .el-form-item__content {
    display: flex;
  }
  &-form {
    width: 40%;
    margin: 0 auto;
  }
  
}
</style>
